import { Trans, useTranslation } from "react-i18next";
import AccordionItem from "./AccordionItem";

const Accordion = ({ contentKey, agents, components }) => {
    const { t } = useTranslation();

    return (
        <>
            {t(contentKey, { returnObjects: true}).map((item,id) => (
                <AccordionItem item={item} agents={agents} key={id} components={components}/>
            ))}
        </>
    )
}

export default Accordion;